import {Test} from 'lib/test'
import * as React from 'react'
import {CircularProgressBar} from "app/Components/ProgressBar";
import {GenericReflexForm} from ".";

type PreviewProps = {
    test: Test
}

export class GenericReflexRawData extends React.Component<PreviewProps> {
    public render = () => <>
        {this.props.test && this.props.test.content ?
            <GenericReflexForm data={this.props.test.content.data} preview={true} /> : <CircularProgressBar/>
        }
    </>
}